import {
  SEARCH_BUYER,
  SEARCH_BUYER_SUCCESS,
  SEARCH_BUYER_ERROR,
  SEARCH_BUYER_PAGE,
  SEARCH_BUYER_PAGE_SUCCESS,
  SEARCH_BUYER_PAGE_ERROR
} from './SearchBuyer.actions'

const searchBuyerState = {
  error: undefined,
  buyers: {},
  buyersView: [],
  page: 1,
  searching: false,
  success: undefined,
  totalPages: 1,
  totalRecordsCount: 0,
  searchOption: {
    searchType: 1,
    dni: '',
    orgLegalName: ''
  }
}

/**
 * The Search Buyers's reducer.
 */
const searchBuyerReducer = (state = searchBuyerState, { payload, type }) => {
  switch (type) {
    case SEARCH_BUYER: {
      return { ...state, searching: true }
    }
    case SEARCH_BUYER_SUCCESS: {
      return {
        ...state,
        searching: false,
        success: true,
        buyers: payload.buyers,
        buyersView: payload.buyersView,
        page: 1,
        totalPages: payload.totalPages,
        totalRecordsCount: payload.totalRecordsCount,
        error: undefined,
        searchOption: payload.searchOption
      }
    }
    case SEARCH_BUYER_ERROR: {
      return {
        ...state,
        searching: false,
        success: false,
        error: { code: payload.code, message: payload.message, title: payload.title }
      }
    }
    case SEARCH_BUYER_PAGE: {
      return { ...state, searching: true }
    }
    case SEARCH_BUYER_PAGE_SUCCESS: {
      return {
        ...state,
        searching: false,
        success: true,
        buyers: payload.buyers,
        buyersView: payload.buyersView,
        page: payload.page,
        error: undefined
      }
    }
    case SEARCH_BUYER_PAGE_ERROR: {
      return {
        ...state,
        searching: false,
        success: false,
        error: { code: payload.code, message: payload.message, title: payload.title }
      }
    }
    default: {
      return state
    }
  }
}

export default searchBuyerReducer
